import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link } from 'gatsby-theme-material-ui';
import Section from '../../shared/Section/Section';
import styles from './styles';
import ModalBlock from '../../shared/ModalBlock/ModalBlock';
import ConsultationModal from '../../shared/Modals/ConsultationModal';
import { sendYandexMetrikaEvent } from '../../helpers/yandexMetrika';
import { sendMyTargetEvent } from '../../helpers/myTarget';

const formData = {
  title: 'Оставьте ваши контакты для связи',
  subtitle: 'Получить консультацию',
  sentContent: {
    title: 'Успешно записаны на консультацию!',
    message: 'Скоро с вами свяжется куратор',
  },
};

function Questions({
  message,
  actions: { first, second, reverseButtons },

  extraLeadData,
  withoutBg = false,
  ymEvents = {},
  myTargetEvents = {},
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Section
      anchor={'questions'}
      theme="medium"
      customStyles={styles.section}
      bg="questions"
      withoutBg={withoutBg}
    >
      <Box sx={styles.contentWrapper}>
        <Typography
          component={'h2'}
          variant={second ? 'desktopH2' : 'desktopH3'}
          sx={styles.message(!!second)}
        >
          {message}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: { xs: 'column', lg: 'row' },
            gap: { lg: 3 },
          }}
        >
          <Button
            onClick={() => setIsOpen(true)}
            variant={second ? 'outlined' : 'kitPrimary'}
            size="large"
            sx={styles.leftLink}
          >
            {first.title}
          </Button>

          {second && (
            <Link href={second.link} sx={styles.rightLink}>
              <Button
                variant="kitPrimary"
                size="large"
                component="span"
                tabIndex={-1}
                onClick={() => {
                  sendYandexMetrikaEvent(ymEvents.mainProgrammsBottomClick);
                  sendMyTargetEvent(myTargetEvents.mainProgrammsBottomClick);
                }}
              >
                {second.title}
              </Button>
            </Link>
          )}
        </Box>
      </Box>

      <ModalBlock isOpen={isOpen} handleClose={() => setIsOpen(false)}>
        <ConsultationModal
          extraLeadData={extraLeadData}
          formData={formData}
          ymSubmitEventTypes={[ymEvents.consultationFormSubmit]}
          myTargetEventTypes={[myTargetEvents.consultationFormSubmit]}
        />
      </ModalBlock>
    </Section>
  );
}

export default Questions;
